export const EMAIL_ATTACHMENT_SIZE_LIMIT = 6.5 * 1024 * 1024; // 6.5MB before EmailLabs base64 encoding
